import { render, staticRenderFns } from "./ContactUs.vue?vue&type=template&id=d89c1634&scoped=true&"
import script from "./ContactUs.vue?vue&type=script&lang=ts&"
export * from "./ContactUs.vue?vue&type=script&lang=ts&"
import style0 from "./ContactUs.vue?vue&type=style&index=0&id=d89c1634&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d89c1634",
  null
  
)

export default component.exports